import { Navigate, Route } from "react-router";

import { FundingDetailPage } from "../funding-list/FundingDetailPage";
import { FundingListPage } from "../funding-list/FundingListPage";
import { FundingRankingPage } from "../funding-list/FundingRankingPage";
import { IdeasPage } from "../ideas/IdeasPage";
import { LegacyDraftRedirect, WorkshopDraftPage } from "./WorkshopDraftPage";
import { WorkshopListPage } from "./WorkshopListPage";
import { WorkshopNewPage } from "./WorkshopNewPage";

/** Route elements for both CustomRoutes blocks in CRM.tsx (desktop and mobile); #/entwurf/<id> and #/neu are the old Werkstatt paths. */
export const workshopRoutes = [
  <Route key="workshop" path="/workshop" element={<WorkshopListPage />} />,
  <Route
    key="workshop-new"
    path="/workshop/new"
    element={<WorkshopNewPage />}
  />,
  <Route
    key="workshop-draft"
    path="/workshop/draft/:id"
    element={<WorkshopDraftPage />}
  />,
  <Route key="ideas" path="/ideas" element={<IdeasPage />} />,
  <Route
    key="funding-list"
    path="/funding-list"
    element={<FundingListPage />}
  />,
  <Route
    key="funding-list-ranking"
    path="/funding-list/ranking"
    element={<FundingRankingPage />}
  />,
  <Route
    key="funding-list-application"
    path="/funding-list/:id"
    element={<FundingDetailPage />}
  />,
  <Route
    key="legacy-draft"
    path="/entwurf/:id"
    element={<LegacyDraftRedirect />}
  />,
  <Route
    key="legacy-new"
    path="/neu"
    element={<Navigate to="/workshop/new" replace />}
  />,
];
